<template>
    <div
        id="tutorials_div"
        :class="showTutorialList ? 'active' : ''"
        v-click-outside="onClickOutsideTutorial"
    >
        <div
            class="box__icon--tutorial"
            style="cursor: pointer"
            @click="onClickShowTutorialList"
        >
            <div
                id="icon_tutorial"
                class="has--tutorial"
                :class="checkRouteModule ? 'bo-class' : 'normal-class'"
            >
                <img
                    src="/images/_SVGs/play.svg"
                    onload="SVGInject(this)"
                    width="100%"
                />
            </div>
        </div>

        <v-slide-y-transition>
            <v-card
                class="container__list arrow_card"
                v-show="showTutorialList"
                style="z-index: 1"
            >
                <div class="triangle"></div>
                <div class="square"></div>
                <div
                    class="header d-flex"
                    style="
                        border-bottom: 1px solid #9e9d9d;
                        position: relative;
                        z-index: 2;
                    "
                >
                    <v-col sm="12">
                        <v-row class="p-0">
                            <v-col sm="6" class="d-flex justify-start p-0">
                                <div class="tutorial-title">
                                    <p class="mb-2">
                                        {{ $t("b2b.tutorials") }}
                                    </p>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row style="height: 15px"></v-row>
                    </v-col>
                </div>

                <div>
                    <div class="body-tutorial">
                        <div
                            v-if="tutorials && tutorials.length > 0"
                            class="d-flex flex-column"
                        >
                            <div
                                v-for="(video, index) in tutorials"
                                :key="index"
                            >
                                <v-col
                                    class="d-flex flex-row p-0 row---div--tutorial"
                                    :key="index"
                                    @click="
                                        redirectToPlaylist(
                                            video.videoId,
                                            video.playlistId
                                        )
                                    "
                                >
                                    <v-col :cols="12">
                                        <div
                                            class="d-flex flex-row justify-content-between align-center"
                                        >
                                            <p
                                                class="body-msg"
                                                style="
                                                    width: 85%;
                                                    margin-bottom: 0px;
                                                "
                                            >
                                                {{ video.title }}
                                            </p>
                                            <img
                                                class="mr-2 white--text"
                                                width="40px"
                                                onload="SVGInject(this)"
                                                src="/images/_SVGs/play-circle-outline.svg"
                                            />
                                        </div>
                                    </v-col>
                                </v-col>
                            </div>
                        </div>
                        <div
                            v-else
                            class="d-flex flex-column"
                            style="text-align: center"
                        >
                            <v-col>
                                <span>{{ $t("zero-tutorials") }}</span>
                            </v-col>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-slide-y-transition>
    </div>
</template>

<script>
import mixinTutorials from "@mixins/b2b/tutorials.js";

export default {
    name: "tutorialsComponent",
    mixins: [mixinTutorials],
    data() {
        return {
            showTutorialList: false,
            isTutorialsTab: false,
        };
    },
    computed: {
        checkRouteModule() {
            const str = this.$route.fullPath;
            return str.indexOf("backoffice") != -1;
        },
        tutorials() {
            return this.$store.getters["tutorials/getTutorialsState"].tutorials;
        },
    },
    watch: {
        tutorialsList: {
            handler: function (newValue, oldValue) {
                return newValue;
            },
            deep: true,
            immediate: true,
        },
        showTutorialList: {
            handler: function (newValue, oldValue) {
                if (newValue) {
                    $("#icon_tutorial").addClass("active");
                    if (!this.tutorials || this.tutorials.length == 0) {
                        this.getVideosFromPlaylist();
                    }
                } else {
                    $("#icon_tutorial").removeClass("active");
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        onClickShowTutorialList() {
            this.showTutorialList = !this.showTutorialList;
        },
        onClickOutsideTutorial() {
            this.showTutorialList = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";

#tutorials_div {
    .icon--tutorial {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: $grey-medium;
        color: $grey-dark;
        transition: ease $animations-time-duration;

        &:hover {
            svg {
                path {
                    fill: var(--v-primary-lighten1);
                }
            }
        }
        &:hover,
        &:active {
            background: #006082 !important;
            svg {
                g {
                    g {
                        path {
                            fill: #006082 !important;
                        }
                    }
                }
            }
        }
    }

    ::v-deep .has--tutorial.normal-class {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: var(--v-primary-base) !important;
        color: $grey-dark;
        transition: ease $animations-time-duration;

        svg {
            .st0 {
                fill: var(--v-primary-base) !important;
            }
            g {
                g {
                    path {
                        stroke: #fff !important;
                    }
                }
            }
        }

        &:hover,
        &.active {
            background: var(--v-primary-darken1) !important;

            svg {
                g {
                    g {
                        path {
                            fill: var(--v-primary-darken1) !important;
                        }
                    }
                }
            }
        }
    }

    ::v-deep .has--tutorial.bo-class {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: var(--v-primary-base) !important;
        color: $grey-dark;
        transition: ease $animations-time-duration;

        svg {
            .st0x {
                fill: var(--v-primary-base) !important;
            }
        }

        &:hover,
        &.active {
            background: var(--v-primary-darken1) !important;

            svg {
                g {
                    g {
                        path {
                            fill: var(--v-primary-darken1) !important;
                        }
                    }
                }
            }
        }
    }

    .triangle {
        position: absolute;
        top: -30px;
        right: 0;
        width: 0;
        border-left: 30px solid transparent;
        border-bottom: 30px solid white;
        -webkit-filter: drop-shadow(5px -5px 10px #9e9d9d);
        filter: drop-shadow(0px 3px 10px black);
    }
    .square {
        background-color: white;
        position: absolute;
        right: 0;
        top: 0;
        width: 50px;
        height: 30px;
        z-index: 1;
    }

    .container__list {
        box-shadow: 5px 5px 10px #9e9d9d;
        padding: 10px;
        top: 90px;
        background-color: $white;
        position: absolute;
        width: 430px;
        margin-left: -407px;
        max-height: 600px;
        color: $grey-dark;
        max-height: 485px;
        border-radius: 10px 0 10px 10px;

        .body-tutorial {
            cursor: pointer;
            max-height: 342px;
            overflow: auto;
            .span--title {
                font-weight: bold;
                font-size: 16px;
            }
            .span--isRead {
                color: #9e9d9d;
                float: right;
                &:hover {
                    color: var(--v-primary-base);
                }
            }
            .active-read {
                color: var(--v-primary-base);
            }
            .row---div--tutorial {
                position: relative;
                border-bottom: 1px solid #9e9d9d;
                padding: 0;
                &:hover {
                    /* border-left: 10px solid var(--v-primary-base); */
                    box-shadow: 0 1px 6px var(--v-primary-lighten2);
                }
            }

            .body-msg {
                font: normal normal bold 14px/18px Lato;
                letter-spacing: 0px;
                margin-bottom: 0px;
                max-width: 94%;
            }

            .date-msg {
                font: normal normal bold 10px/12px Lato;
                letter-spacing: 0px;
            }

            .underline-msg {
                font: normal normal bold 10px/12px Lato;
                letter-spacing: 0px;
                color: var(--v-primary-base);
                text-decoration: underline;
            }
        }

        .checkbox-see-all {
            &::v-deep label {
                margin-bottom: 0px !important;
            }
        }
    }

    .v-input--selection-controls {
        margin-top: 0px !important;
        padding-top: 4px;
    }

    .tutorial-title {
        border-radius: 12px;
        width: 107px;
        display: flex;
        justify-content: center;
        p {
            margin-top: 8px;
            color: #3e3c3d;
            font-size: 16px;
            font-weight: bold;
        }

        a {
            margin-top: 8px;
            font-size: 14px;
        }
    }

    .span-btn-modal {
        color: var(--v-primary-base);
        text-transform: capitalize;
        font-weight: bold;
    }

    .primary-button {
        border: 1px solid var(--v-primary-base);

        font-weight: 600;
        color: var(--v-primary-base);
        border-radius: 43px;
        background: transparent !important;
        &:hover {
            background: var(--v-primary-base) !important;
            color: #fff;
            
            .span-btn-modal {
                color: #fff;
            }
            &::v-deep svg {
                g {
                    g {
                        g {
                            g {
                                path {
                                    stroke: white !important;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 426px) {
        .container__list {
            margin-left: 0px;
            left: 0;
            right: 0;
            top: 70px;
        }
    }

    .fix-top {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 6px;
        padding-bottom: 0;
        flex-direction: row;
        height: 30px;
    }

    .read-message {
        margin-top: 6px;
        padding-right: 0;
        padding-bottom: 0;
        text-align: end;
    }

    .tutorial-container {
        display: flex;
        position: absolute;
        right: 0;
        width: fit-content;
    }
}
</style>
